export default __webpack_public_path__ + "static/media/camera.09f4e6ff.svg";